(() => {
  document.querySelectorAll('[data-ob-catalog]').forEach(catalog => {
    if (catalog.dataset.initialized) return;
    catalog.dataset.initialized = 'true';
    const grid = catalog.querySelector('.ob-grid');
    const cards = [...catalog.querySelectorAll('[data-ob-item]')];
    const search = catalog.querySelector('[data-ob-search]');
    const category = catalog.querySelector('[data-ob-category]');
    const wood = catalog.querySelector('[data-ob-wood]');
    const sort = catalog.querySelector('[data-ob-sort]');
    const reset = catalog.querySelector('[data-ob-reset]');
    const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const woodTerms = {eiche:'oak',δρυς:'oak',дуб:'oak',buche:'beech',οξια:'beech',бук:'beech',esche:'ash',φραξος:'ash',ясень:'ash',walnuss:'walnut',καρυδια:'walnut',орех:'walnut'};
    function filter() {
      const term = normalize(search.value.trim());
      const words = term.split(/\s+/).map(word => woodTerms[word] || word);
      let count = 0;
      cards.forEach(card => {
        const visible = (!category.value || card.dataset.category === category.value) && (!wood.value || card.dataset.wood.split(' ').includes(wood.value)) && words.every(word => normalize(card.dataset.search).includes(word));
        card.hidden = !visible;
        if (visible) count++;
      });
      const ordered = [...cards].sort((a,b) => sort.value === 'low' ? Number(a.dataset.price)-Number(b.dataset.price) : sort.value === 'high' ? Number(b.dataset.price)-Number(a.dataset.price) : sort.value === 'name' ? a.dataset.name.localeCompare(b.dataset.name) : Number(a.dataset.index)-Number(b.dataset.index));
      ordered.forEach(card => grid.append(card));
      catalog.querySelector('[data-ob-count]').textContent = count;
      catalog.querySelector('[data-ob-empty]').hidden = count !== 0;
      reset.hidden = !term && !category.value && !wood.value && sort.value === 'curated';
    }
    search.addEventListener('input', filter);
    [category,wood,sort].forEach(control => control.addEventListener('change', filter));
    reset.addEventListener('click', () => { search.value='';category.value='';wood.value='';sort.value='curated';filter();search.focus(); });
    catalog.querySelector('[data-ob-controls]').hidden = false;
    cards.forEach(card => {
      const option = card.querySelector('[data-ob-option]');
      const quantity = card.querySelector('[data-ob-quantity]');
      function updateInquiry() {
        const amount = Math.min(999,Math.max(1,Math.trunc(Number(quantity.value)) || 1));
        const choice = option.selectedOptions[0];
        const canonical = new URL(catalog.dataset.obUrl, location.origin);
        canonical.hash = card.id;
        const values = {product:card.dataset.name,option:choice.dataset.optionLabel || choice.value,quantity:String(amount),price:choice.dataset.priceLabel || choice.dataset.price,url:canonical.href};
        const body = catalog.dataset.obInquiryTemplate.replace(/%([a-z]+)%/g, (match,key) => values[key] ?? match);
        card.querySelector('[data-ob-email]').href = `mailto:office@nu-liv.com?subject=${encodeURIComponent('Oak & Beech - '+card.dataset.name)}&body=${encodeURIComponent(body)}`;
        card.querySelector('[data-ob-whatsapp]').href = `https://wa.me/35797529479?text=${encodeURIComponent(body)}`;
      }
      option.addEventListener('change',updateInquiry);quantity.addEventListener('input',updateInquiry);updateInquiry();
    });
    function openHash() {
      const id = decodeURIComponent(location.hash.slice(1));
      const card = cards.find(item => item.id===id);
      if (!card) return;
      search.value='';category.value='';wood.value='';filter();
      card.querySelector('details').open=true;
      requestAnimationFrame(() => card.scrollIntoView({block:'start'}));
    }
    window.addEventListener('hashchange',openHash);
    openHash();
  });
})();
